const withSessionQnaApi = (Base) => class extends Base {
  async getSessionQna(sessionId) {
    return this.request(`/attendance/${sessionId}/qna`);
  }

  async postSessionQuestion(sessionId, body, isAnonymous = false) {
    return this.request(`/attendance/${sessionId}/qna/questions`, {
      method: 'POST',
      body: JSON.stringify({ body, is_anonymous: isAnonymous }),
    });
  }

  async postSessionQuestionReply(sessionId, questionId, body, { replyToId = null, isAnonymous = false } = {}) {
    return this.request(`/attendance/${sessionId}/qna/questions/${questionId}/replies`, {
      method: 'POST',
      body: JSON.stringify({ body, reply_to_id: replyToId, is_anonymous: isAnonymous }),
    });
  }

  async toggleSessionQnaReaction(sessionId, targetType, targetId, reactionType) {
    return this.request(`/attendance/${sessionId}/qna/${targetType}/${targetId}/reactions`, {
      method: 'POST',
      body: JSON.stringify({ reaction_type: reactionType }),
    });
  }

  async editSessionQnaMessage(sessionId, targetType, targetId, body) {
    return this.request(`/attendance/${sessionId}/qna/${targetType}/${targetId}`, {
      method: 'PATCH',
      body: JSON.stringify({ body }),
    });
  }

  async setSessionQuestionAnswered(sessionId, questionId, answered) {
    return this.request(`/attendance/${sessionId}/qna/questions/${questionId}/answered`, {
      method: 'PATCH',
      body: JSON.stringify({ answered }),
    });
  }

  async deleteSessionQnaMessage(sessionId, targetType, targetId) {
    return this.request(`/attendance/${sessionId}/qna/${targetType}/${targetId}`, {
      method: 'DELETE',
    });
  }
};

export default withSessionQnaApi;
